import { useEffect } from 'react';

import { env } from '@/shared/config/env';

import { AppProviders } from './providers/AppProviders';
import { AppRoutes } from './router/routes';

/** Application root: composes providers and renders the active route. */
export default function App() {
  useEffect(() => {
    document.title = env.appName;
  }, []);

  return (
    <AppProviders>
      <AppRoutes />
    </AppProviders>
  );
}
